import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import logo from '../../assets/images/invertLogo.png';
import { useLegalDocument } from '../../hooks/useLegalDocument';
import './TOS.css';

function formatUpdatedAt(iso) {
    if (!iso) return null;
    try {
        return new Date(iso).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    } catch {
        return null;
    }
}

export default function TOS() {
    const navigate = useNavigate();
    const { doc, loading, error } = useLegalDocument('advertiser_tos');

    const updatedLabel = doc?.updatedAt
        ? formatUpdatedAt(doc.updatedAt)
        : 'May 18, 2026';

    return (
        <div className="tos-page">
            <nav className="tos-nav">
                <button type="button" className="tos-nav-brand" onClick={() => navigate('/')}>
                    <img src={logo} alt="INVERT logo" />
                    <span>INVERT</span>
                </button>
                <button type="button" className="tos-nav-home" onClick={() => navigate('/')}>
                    Back to home
                </button>
            </nav>

            <main className="tos-main">
                <article className="tos-article">
                    {loading && <p className="tos-loading">Loading terms…</p>}
                    {error && <p className="tos-error">{error}</p>}
                    {!loading && !error && doc && (
                        <>
                            <header className="tos-header">
                                <h1>{doc.title}</h1>
                                <p className="tos-updated">
                                    Last Updated: {updatedLabel} (version {doc.version})
                                </p>
                            </header>
                            <div className="tos-markdown">
                                <ReactMarkdown>{doc.body}</ReactMarkdown>
                            </div>
                        </>
                    )}
                </article>
            </main>

            <footer className="tos-footer">
                <Link to="/">Return to INVERT home</Link>
            </footer>
        </div>
    );
}
